import { supabase } from './supabase'
import type { PlanId } from '../plans'

/**
 * Devam talebi (Ayarlar > Hesabım). "renewal" fonksiyonu talebi kaydedip
 * info@adissoo.com'a haber veriyor; bekleyen talep varsa yenisini açmıyor.
 * Dönen tarih, bekleyen talebin ne zaman gönderildiği (yoksa null).
 */
async function call(action: 'status' | 'request', tenantId: string, want?: PlanId): Promise<string | null> {
  if (!supabase) throw new Error('Bağlantı yok.')
  const { data, error } = await supabase.functions.invoke('renewal', { body: { action, tenantId, want } })
  if (error) throw new Error('Gönderilemedi. İnternet bağlantınızı kontrol edin.')
  if (data?.error) throw new Error(String(data.error))
  return typeof data?.pending === 'string' ? data.pending : null
}

export const renewalStatus = (tenantId: string) => call('status', tenantId)
/** want: yükseltme talebinde istenen paket (29 Eki 2026); yoksa düz devam talebi. */
export const requestRenewal = (tenantId: string, want?: PlanId) => call('request', tenantId, want)
